import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 24 24", ...l }, /* @__PURE__ */ e.createElement("path", { d: "M12.704 2.229a.78.78 0 0 0-1.408 0L8.474 8.142 1.978 9a.78.78 0 0 0-.435 1.339l4.752 4.51-1.193 6.443a.78.78 0 0 0 1.14.828L12 18.993l5.759 3.126a.78.78 0 0 0 1.139-.828l-1.193-6.442 4.752-4.511a.78.78 0 0 0-.435-1.34l-6.496-.856-2.822-5.913Z" }));
export {
  t as default
};
//# sourceMappingURL=review-full-icon-0ltgqBjM.js.map
